import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Subject } from "rxjs";
export const CHANNEL_ORDER_DATA_ACTION_SERVICE: string = "OrderDataActionServiceChannel";

export interface IOrderDataActionService {
  quickFillOrders(ids: Array<string>, stpRequirement: CubiqTS.FillStpRequirement): Promise<boolean>;
  reactivateOrders(orderIds: Array<string>, fromDetailFill?: boolean): Promise<any>;
  cancelOrders(orderIds: Map<string, string[]>, reason: string): Promise<any>;
  submitNewOrder(request: CubiqTS.LinkedOrderRequestImpl): Promise<any>;
  submitBmarkOrder(request: CubiqTS.FixingOrderRequestImpl): Promise<any>;
  submitModifiedOrder(request: CubiqTS.LinkedOrderModificationRequestImpl): Promise<any>;
  submitModifyInfo(request: CubiqTS.LinkedOrderInfoModificationRequestImpl): Promise<any>;
  modifyOrderLock(orderId: string): Promise<any>;
  modifyOrdersUnlock(orderIds: Array<string>): Promise<any>;
  getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable>;
  lockOrdersForFill(orders: Array<CubiqTS.OrderDataImpl>): Promise<any>;
  unlockOrdersFromFill(orderIds: Array<string>): Promise<any>;
  releaseOrder(ids: Array<string>, orderType: CubiqTS.OrderType): Promise<void>;
  toggleInflightInclusionState(
    orderIds: CubiqTS.Long[],
    state: CubiqTS.InflightInclusionState,
  ): Promise<CubiqTS.ToggleInflightStateResult>;
}
